module.exports = __webpack_public_path__ + "media/images/gifts/open_end/sug_aberto_10-ae1eadb0e7005f8c4f494966014b2c43.jpg";